import { push } from 'connected-react-router';
import { getAuctionEditUrl } from 'utils/auction';
import {
    Banner,
    Campaign,
    convertCampaignSourcesFromDto,
    getBannerCreateBatchActions,
    getBannerEditBatchActions,
    getBannerIdFromMatch,
    getCampaignIdFromMatch,
} from 'utils/campaign';
import { sortProfRoles } from 'utils/clickme';
import { CampaignProcess, CampaignProductType } from 'utils/constants/campaign';
import { BEProfRoles } from 'utils/profRoles';

import { ModelData } from '@hh.ru/magritte-ui';

import { Match, Requirements } from 'app/routes';

import store from 'store';
import { PROF_ROLES, setErirClassificationCatalog, setProfRoles } from 'store/autoReducers';
import { setCampaignProcess, setCampaignProfessions } from 'store/models/createCampaign';

const isBannerEdit = (match: Match['match']) => Boolean(getBannerIdFromMatch(match));

export const BannerBuilderPageRequirements: Requirements<{
    campaign: Campaign;
    banner: Banner;
    [PROF_ROLES]: BEProfRoles;
    erirClassificationCatalog: ModelData[];
}> = {
    methods: ({ match }) => {
        const campaignId = getCampaignIdFromMatch(match) || '';
        const bannerId = getBannerIdFromMatch(match) || '';
        return {
            campaign: { url: `/api/v1/campaigns/${campaignId}`, cacheable: false },
            ...(isBannerEdit(match) && {
                banner: { url: `/api/v1/banners/${bannerId}`, cacheable: false },
            }),
            erirClassificationCatalog: { url: '/api/v1/catalog/erir/classification/tree' },
            [PROF_ROLES]: {
                url: '/api/v1/catalog/professionalCatalog',
            },
        };
    },
    resolve: ({ result: { campaign, banner, erirClassificationCatalog, ...professions }, match }) => {
        if (campaign.productType === CampaignProductType.SearchAuction && campaign.vacancyId) {
            // если по ошибке открыли аукцион, не даем редактировать, редиректим на правильную форму
            const auctionUrl = getAuctionEditUrl(campaign.vacancyId);
            store.dispatch(push(auctionUrl));
            return [];
        }

        return [
            setCampaignProcess(CampaignProcess.Create),
            setErirClassificationCatalog(erirClassificationCatalog),
            setProfRoles(sortProfRoles(professions[PROF_ROLES].professionalCategories)),
            setCampaignProfessions(campaign.professionalRoles?.map(String) ?? []),
            ...getBannerCreateBatchActions({
                campaign: {
                    ...campaign,
                    apiSources: convertCampaignSourcesFromDto(campaign.campaignSources),
                },
                campaignIdForBanner: String(getCampaignIdFromMatch(match)),
            }),
            ...(isBannerEdit(match) ? getBannerEditBatchActions({ banner }) : []),
        ];
    },
};
